// NPM Imports
import React from "react";

// Chart Imports
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import ReactFC from "react-fusioncharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Internal Imports
import { DASHBOARD } from "../../../../constants";

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Charts, FusionTheme);

// Destructuring
const { SCROLL_STACKED_COLUMN_CHART_CONFIGS } = DASHBOARD;

/**
 * :: StackedColumnChart ::
 * (for showing the data in "Stacked Column" chart format with chart type 'scrollstackedcolumn2d')
 *  - uses const 'SCROLL_STACKED_COLUMN_CHART_CONFIGS' which includes the base configurations for chart
 *  - need to pass the followings props,
 *    1. 'chart'       - chart related configs
 *    2. 'categories'  - for showing the x-axis labels
 *    3. 'dataset'     - for showing the stacked column data
 *    4. 'width'       - chart container width
 *    5. 'height'      - chart container height
 *  - for more details 'https://www.fusioncharts.com/dev/chart-attributes/stackedcolumn2d'
 */
const StackedColumnChart = props => {
  const {
    width,
    height,
    configs: { chart, categories, dataset },
  } = props;

  const chartConfigs = JSON.parse(
    JSON.stringify(SCROLL_STACKED_COLUMN_CHART_CONFIGS),
  );
  chartConfigs.width = width;
  chartConfigs.height = height;
  chartConfigs.dataSource = {
    ...chartConfigs.dataSource,
    chart: {
      ...chartConfigs.dataSource.chart,
      ...chart,
    },
    categories,
    dataset,
  };
  console.debug("Rendring the StackedColumnChart....");
  return <ReactFC {...chartConfigs} />;
};

export default StackedColumnChart;



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/Charts/StackedColumnChart/index.js